import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EPermissions } from '@enums/permissions.enum';
import { ContentContainerComponent } from '@shared/components/content-container/content-container.component';
import { ICreateEntityButtonConfiguration } from '@shared/components/create-entity-button/create-entity-button.interface';
import { CreateCustomerDialogComponent } from './create-customer-dialog/create-customer-dialog.component';
import { ICreateCustomerDialogData } from './create-customer-dialog/create-customer-dialog.interface';
import { CustomersBannerComponent } from './customers-banner/customers-banner.component';
import { CustomersDatatableComponent } from './customers-datatable/customers-datatable.component';
import { CustomersStore } from './customers.store';

@Component({
  imports: [CustomersDatatableComponent, CustomersBannerComponent, ContentContainerComponent],
  providers: [CustomersStore],
  selector: 'app-customers',
  templateUrl: './customers.component.html',
})
export class CustomersComponent {
  public readonly addButtonConfiguration: ICreateEntityButtonConfiguration = {
    labelKey: 'pages.customers.datatable.newCustomer',
    onClick: this.onCreateClick.bind(this),
    permissions: [EPermissions.customerCreate],
  };

  public readonly store = inject(CustomersStore);
  private readonly dialog = inject(MatDialog);

  constructor() {
    this.store.fetchCustomers();
  }

  private onCreateClick(): void {
    const data: ICreateCustomerDialogData = {
      customer: null,
      redirectToCustomerDetails: true,
    };

    this.dialog.open(CreateCustomerDialogComponent, {
      autoFocus: true,
      data,
      minWidth: '700px',
    });
  }
}
